import React, { useEffect, useRef } from "react";

const Starfield = () => {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let raf;
    let stars = [];
    let shooting = null;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);

    const resize = () => {
      const { offsetWidth: w, offsetHeight: h } = canvas.parentElement;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      canvas.style.width = `${w}px`;
      canvas.style.height = `${h}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      stars = Array.from({ length: Math.floor((w * h) / 9000) + 40 }, () => ({
        x: Math.random() * w,
        y: Math.random() * h,
        r: Math.random() * 1.4 + 0.3,
        p: Math.random() * Math.PI * 2,
        s: 0.4 + Math.random() * 0.8,
        gold: Math.random() < 0.3,
      }));
    };

    const tick = (t) => {
      const { offsetWidth: w, offsetHeight: h } = canvas.parentElement;
      ctx.clearRect(0, 0, w, h);
      for (const star of stars) {
        const a = 0.25 + 0.55 * (0.5 + 0.5 * Math.sin(t / 1000 * star.s + star.p));
        ctx.beginPath();
        ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
        ctx.fillStyle = star.gold
          ? `rgba(243, 208, 104, ${a})`
          : `rgba(199, 210, 254, ${a * 0.8})`;
        ctx.fill();
      }
      if (!shooting && Math.random() < 0.004) {
        shooting = { x: Math.random() * w * 0.7 + w * 0.2, y: Math.random() * h * 0.3, vx: -4.5, vy: 2.2, life: 1 };
      }
      if (shooting) {
        shooting.x += shooting.vx;
        shooting.y += shooting.vy;
        shooting.life -= 0.02;
        const grad = ctx.createLinearGradient(
          shooting.x,
          shooting.y,
          shooting.x - shooting.vx * 16,
          shooting.y - shooting.vy * 16
        );
        grad.addColorStop(0, `rgba(243,208,104,${Math.max(shooting.life, 0)})`);
        grad.addColorStop(1, "rgba(243,208,104,0)");
        ctx.strokeStyle = grad;
        ctx.lineWidth = 1.4;
        ctx.beginPath();
        ctx.moveTo(shooting.x, shooting.y);
        ctx.lineTo(shooting.x - shooting.vx * 16, shooting.y - shooting.vy * 16);
        ctx.stroke();
        if (shooting.life <= 0) shooting = null;
      }
      raf = requestAnimationFrame(tick);
    };

    resize();
    raf = requestAnimationFrame(tick);
    window.addEventListener("resize", resize);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={ref} className="absolute inset-0 pointer-events-none" aria-hidden="true" />;
};

export default Starfield;
